module.exports = __webpack_public_path__ + "media/images/home_courses-896463c97338cdbf771d4deb81b2e7cf.png";